
export const tutorialSections = [
  {
    id: 1,
    title: "Intro Walkthrough",
    transcriptContent: `<p>CloudSous is a new platform that aims to revolutionize how chefs share and monetize their recipes, similar 
      to how music streaming transformed the music industry. Instead of purchasing entire cookbooks, users can access 
      specific recipes they want through a streaming-style platform. The platform allows chefs to upload their recipes and earn 
      revenue through a subscription model.</p>
      <p>The platform features include a personal chef page where fans can interact with an AI agent specifically 
      trained on the chef's recipes. This AI can help users find recipes for specific occasions, adjust serving sizes, 
      and suggest ingredient substitutions. Chefs can manage their recipe library, create featured collections, and edit 
      their profile information including bio and social media links. The platform will include analytics for tracking recipe 
      performance and revenue. While some features will be freely accessible, premium content will be available only to subscribers, 
      ensuring chefs are compensated for their work. The AI functionality is powered by OpenAI, creating an interactive and 
      personalized experience for users while allowing chefs to maintain control over their content and monetization.</p>
    `,
    videoUrl: "https://www.youtube.com/embed/9M0KSbcMMmU?si=Xg-CdRUKeLhyxlja"
  },
  {
    id: 2,
    title: "Adding & Editing Recipes",
    transcriptContent: `<p>CloudSous offers two main methods for adding recipes to the platform. The first is manual entry, where chefs can 
      input recipe details through a form that includes fields for tags, ingredients (added as chips), and instructions using a powerful 
      Rich Text Editor powered by TinyMCE. The second, more streamlined method allows chefs to upload existing recipe files in PDF format. 
      The system automatically extracts and populates the title, tags, ingredients, and instructions from the PDF, though images need to be
      uploaded separately.</p>
      <p>The platform features a user-friendly interface where recipes can be accessed from the library tab or sidebar. Once uploaded, 
      recipes can be easily edited, and chefs can preview how their recipes will appear to users through the preview function. The system 
      is designed to be intuitive and efficient, with the development team actively seeking user feedback for continued improvements 
      to the upload process.</p>
    `,
    videoUrl: "https://www.youtube.com/embed/V1QJgGWsYf0?si=_OCMBGgBh0PDy-Az"
  },
  {
    id: 3,
    title: "Preview Chef Profile & Edit",
    transcriptContent: `<p>The video demonstrates how to edit profile information on CloudSous. 
      Users can customize their chef page by editing their avatar,
      bio, social media links (Instagram and YouTube), and basic information like username and email. The platform includes validation 
      for social media URLs to ensure they're properly formatted. All changes can be previewed in real-time through the "Preview Chef Page" 
      function, where users can see exactly how their profile will appear to their audience.</p>
      <p>The interface is designed to be straightforward and user-friendly, with immediate visual feedback on changes. While email display is
      currently not available, the platform plans to add the option for chefs to choose whether to display their email address publicly. Social 
      media links are functional and direct visitors to the chef's respective social media pages when clicked.</p>
    `,
    videoUrl: "https://www.youtube.com/embed/gty_MB2RWUY?si=rz3jGixh9a2QUhdY"
  },
  {
    id: 4,
    title: "What's Next",
    transcriptContent: `<p>Planned Features:</p>
      <ul>
      <li>Integration of YouTube videos with corresponding recipes</li>
      <li>AI agent implementation for interactive recipe assistance</li>
      <li>Bulk recipe upload capabilities, including folder uploads</li>
      <li>AI-powered scanning of physical recipe books</li>
      <li>Enhanced profile customization and featured recipe sections</li>
      <li>Recipe statistics and performance tracking</li>
      </ul>
      <p>Business Model:</p>
      <ul>
      <li>Spotify-style subscription model for users</li>
      <li>Revenue split: 70% to chefs, 30% to CloudSous (after costs)</li>
      <li>Chef earnings based on engagement metrics (traffic, bookmarks, ratings)</li>
      <li>Global AI agent that recommends recipes across the platform based on user engagement and ratings</li>
      <li>Focus on recipe discovery and growing chef audiences</li>
      </ul>
      <p>The platform aims to address the future of recipe sharing by creating a legitimate monetization 
      channel for chefs while providing a better user experience for fans. With 250+ people already on the waitlist, 
      CloudSous is focusing first on building out the recipe library with chefs before launching the user-facing features. 
      The company emphasizes collaboration with chefs and offers direct communication channels for feedback and 
      questions during development.</p>
    `,
    videoUrl: "https://www.youtube.com/embed/wBHjTPABSbA?si=0cQf8mseX2x_v0Gu"
  },
];